import React from 'react';
import SolutionDetail from '../components/SolutionDetail';
import CodeIcon from '@mui/icons-material/Code';

const solutionData = {
  id: 'software-development',
  name: 'Software Development',
  icon: <CodeIcon sx={{ fontSize: 60 }} />,
  description: 'Custom software solutions for geospatial and mapping applications',
  overview: `Our software development team specializes in creating custom solutions for geospatial applications, mapping systems, and data management platforms. We develop robust, scalable, and user-friendly applications that help organizations leverage their spatial data effectively. Our expertise spans web-based mapping applications, mobile GIS solutions, and enterprise-level geospatial systems.`,
  features: [
    {
      title: 'Custom GIS Solutions',
      description: 'Tailored geographic information systems for specific needs',
    },
    {
      title: 'Web Mapping Applications',
      description: 'Interactive web-based mapping platforms',
    },
    {
      title: 'Mobile Applications',
      description: 'Field-ready mobile GIS solutions',
    },
    {
      title: 'Data Integration',
      description: 'Seamless integration with existing systems and databases',
    },
    {
      title: 'API Development',
      description: 'Custom APIs for geospatial data access and manipulation',
    },
    {
      title: 'Cloud Solutions',
      description: 'Cloud-based geospatial applications and services',
    },
  ],
  benefits: [
    'Customized to specific needs',
    'Improved workflow efficiency',
    'Enhanced data accessibility',
    'Scalable solutions',
    'Modern technology stack',
    'Ongoing support and maintenance',
  ],
};

const SoftwareDevelopment = () => {
  return <SolutionDetail solution={solutionData} />;
};

export default SoftwareDevelopment; 